import {Route, Routes} from 'react-router-dom'
import HoteleriaPageWrapper from '../khipu/features/hoteleria/pages/HoteleriaPageWrapper'
import BookingsPageWrapper from '../khipu/features/hoteleria/features/bookings/pages/BookingsPage'
import CheckingPageWrapper from "../khipu/features/hoteleria/features/checking/pages/CheckingPage";

const HoteleriaRoutes = () => {
  return (
    <Routes>
      <Route path='reservas' element={<CheckingPageWrapper />} />
      <Route path='checking' element={<BookingsPageWrapper />} />
      <Route index element={<HoteleriaPageWrapper />} />
    </Routes>
  )
}

export {HoteleriaRoutes}
